import React from "react";

const ConfirmationModal = (props) => {
  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };
  return (
    <div className="modal-overlay">
      <div className="outline" onClick={() => props.Close()}></div>
      {props.ConfirmIsSkip ? (
        <section className="modal-body">
          <div className="modal-head">
            {props.Data.candidate.revealIdentity ? (
              <React.Fragment>
                {props.Data.candidate.imageThumbnailUrl === null ? (
                  <span
                    className="avatar-placeholder"
                    style={{
                      color: props.Data.candidate.textColorCode,
                      backgroundColor: props.Data.candidate.backgroundColorCode,
                    }}
                  >
                    <p>
                      {props.Data.candidate.firstName
                        .slice(0, 1)
                        .toUpperCase() +
                        props.Data.candidate.lastName.slice(0, 1).toUpperCase()}
                    </p>
                  </span>
                ) : (
                  <span className="avatar-placeholder">
                    <img
                      alt="candidate"
                      src={props.Data.candidate.imageThumbnailUrl}
                      className="candidate-avatar"
                    />
                  </span>
                )}
              </React.Fragment>
            ) : (
              <span className="incognito">
                <img src={props.AnonymousIcon} />
              </span>
            )}
            <span className="info">
              {props.Data.candidate.revealIdentity ? (
                <p className="candidate-name">
                  {props.Data.candidate.firstName +
                    " " +
                    props.Data.candidate.lastName}
                </p>
              ) : (
                <p className="candidate-name">{translateText("anonymous")}</p>
              )}
              <p className="candidate-position">
                {" "}
                {props.Data.candidate.currentPositionTitle}
              </p>
            </span>
            <i className="feather-x" onClick={() => props.Close()}></i>
          </div>
          <h1 className="modal-message">
            {translateText("confirm_skip_interview_text")}
          </h1>
          <div className="actions">
            <button onClick={() => props.Close()}>Discard</button>
            {props.Data.candidate.revealIdentity ? (
              <button
                className="primary-btn"
                onClick={() => props.AcceptSkipNormalInterview()}
              >
                {translateText("skip_interview")}
              </button>
            ) : (
              <button
                className="primary-btn"
                onClick={() => props.AcceptSkipInterview()}
              >
                {translateText("skip_interview")}
              </button>
            )}
          </div>
        </section>
      ) : (
        <section className="modal-body">
          <div className="modal-head">
            {props.Data.candidate.revealIdentity ? (
              <React.Fragment>
                {props.Data.candidate.imageThumbnailUrl === null ? (
                  <span
                    className="avatar-placeholder"
                    style={{
                      color: props.Data.candidate.textColorCode,
                      backgroundColor: props.Data.candidate.backgroundColorCode,
                    }}
                  >
                    <p>
                      {props.Data.candidate.firstName
                        .slice(0, 1)
                        .toUpperCase() +
                        props.Data.candidate.lastName.slice(0, 1).toUpperCase()}
                    </p>
                  </span>
                ) : (
                  <span className="avatar-placeholder">
                    <img
                      alt="candidate"
                      src={props.Data.candidate.imageThumbnailUrl}
                      className="candidate-avatar"
                    />
                  </span>
                )}
              </React.Fragment>
            ) : (
              <span className="incognito">
                <img src={props.AnonymousIcon} />
              </span>
            )}
            <span className="info">
              <p className="candidate-name">
                {props.Data.candidate.firstName +
                  " " +
                  props.Data.candidate.lastName}
              </p>
              <p className="candidate-position">
                {props.Data.candidate.currentPositionTitle}
              </p>
            </span>
            <i className="feather-x" onClick={() => props.Close()}></i>
          </div>
          {props.ConfirmIsReject ? (
            <h1 className="modal-message">
              {translateText("confirm_reject_candidate_text")}
            </h1>
          ) : (
            <h1 className="modal-message">
              {translateText("confirm_finalize_application_text")}
            </h1>
          )}
          <div className="actions">
            <button onClick={() => props.Close()}>
              {translateText("discard")}
            </button>
            {props.ConfirmIsReject ? (
              <button
                className="reject-btn"
                onClick={() => props.RejectCandidate()}
              >
                {translateText("jpa_action_reject")}
              </button>
            ) : (
              <button
                className="primary-btn"
                onClick={() => props.AcceptCandidate()}
              >
                {translateText("accept_application")}
              </button>
            )}
          </div>
        </section>
      )}
    </div>
  );
};

export default ConfirmationModal;
